var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"initUserIdComponents"},[_c('div',{staticClass:"projectImage"},[_c('el-image',{staticClass:"imageLogo",attrs:{"fit":"scale-down","src":_vm.image}})],1),_c('div',{staticClass:"loadingText"},[_c('i',{staticClass:"el-icon-loading"}),_vm._v(" "+_vm._s(_vm.$t("entering"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }